var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { styled } from 'styled-components';
import { useField } from 'formik';
import { Select } from '../select.js';
import { nonTerritoryStates, usStates } from '@navinc/utils';
export const getStates = (format, withTerritories) => {
    const list = withTerritories ? usStates : nonTerritoryStates;
    const options = list.map((state) => ({ label: state[format], value: state.short }));
    return options.sort((curr, next) => {
        if (curr.label < next.label) {
            return -1;
        }
        if (curr.label > next.label) {
            return 1;
        }
        return 0;
    });
};
const stateRequired = (isRequired = false) => (state) => {
    if (isRequired && !state) {
        return ['State is required'];
    }
};
const UnstyledStateSelect = (_a) => {
    var { name = 'state', label = 'State', onChange, invalidOnTouched = true, format = 'long', withTerritories = true, isRequired, onBlur } = _a, props = __rest(_a, ["name", "label", "onChange", "invalidOnTouched", "format", "withTerritories", "isRequired", "onBlur"]);
    const memoizedValidateZipCode = useMemo(() => stateRequired(isRequired), [isRequired]);
    const [field, meta, { setValue }] = useField({ name, validate: memoizedValidateZipCode });
    const getOptions = useMemo(() => getStates(format, withTerritories), [format, withTerritories]);
    return (_jsx(Select, Object.assign({ label: label, name: name, type: "text", options: getOptions, value: field.value, onChange: (e) => {
            setValue(e.target.value);
            if (onChange) {
                onChange(e);
            }
        }, onBlur: (e) => {
            field.onBlur(e);
            if (onBlur) {
                onBlur(e);
            }
        }, errors: !invalidOnTouched || meta.touched ? meta.error : undefined, isInvalid: (!invalidOnTouched || meta.touched) && !!meta.error, hasSpaceForErrors: true, "data-testid": "state-input" }, props)));
};
/**
 * A default state select drowpdown component to render a list of states and territories (optional) in either abbr format or fully spelled out
 *
 * @deprecated This component is deprecated and will be removed in a future release. Avoid using it in new code.
 */
export const StateSelect = styled(UnstyledStateSelect).withConfig({ displayName: "brc-sc-StateSelect", componentId: "brc-sc-1gyinlb" }) ``;
//# sourceMappingURL=state-select.js.map